import Web3 from "web3";
import { erc20Abi, receiptBridgeAbi } from "../abi";

const web3 = new Web3(window.ethereum);

export const approveTokens = async (account, tokenAddress, amount, spender) => {
  const tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);
  // Get current allowanced
  const currentAllowance = await tokenContract.methods
    .allowance(account, spender)
    .call();
  // Convert both the current allowance and the required amount to big numbers for comparison
  const currentAllowanceBN = currentAllowance;
  const amountBN = amount;
  // If the current allowance is less than the required amount, approve more
  if (currentAllowanceBN < amountBN) {
    const tx = await tokenContract.methods
      .approve(spender, amountBN)
      .send({ from: account });
    return tx;
  } else {
    console.log("Token has already been approved.");
  }
};
export const getTokenData = async (account, tokenAddress) => {
  try {
    const tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);
    const decimal = await tokenContract.methods.decimals().call();
    const symbol = await tokenContract.methods.symbol().call();

    return {
      decimal,
      symbol,
    };
  } catch (error) {
    console.error("Error retrieving token data:", error);
    throw error;
  }
};

export const approveToken = async (account, spender, payArgs) => {
  try {
    const { decimal, symbol } = await getTokenData(account, payArgs[1]);
    await approveTokens(account, payArgs[1], payArgs[0], spender);
  } catch (error) {
    console.error("Error occurred during approving:", error);
    throw error;
  }
};
export const pay = async (account, contractAddress, payArgs) => {
  try {
    const contract = new web3.eth.Contract(receiptBridgeAbi, contractAddress);
    const res=await contract.methods
      .pay(
        payArgs[0],
        payArgs[1],
        payArgs[2],
        payArgs[3],
        payArgs[4],
        payArgs[5],
        payArgs[6],
        payArgs[7]
      )
      .send({ from: account });

  } catch (error) {
    console.error("Error occurred during payment:", error);
    throw error;
  }
};
